import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ExpandService {
  readonly isExpanded = signal<boolean>(false);

  /** @deprecated Use isExpanded() signal instead */
  getExpandState(): boolean {
    return this.isExpanded();
  }

  toggleExpandState(): void {
    this.isExpanded.update(current => !current);
  }

  setExpandState(value: boolean): void {
    this.isExpanded.set(value);
  }
}
